module.exports = __webpack_public_path__ + "media/promo/advent/images/logom-1-944377450b66aa7d75645489d70cfea0.png";